<template>
    <div class="general">
        <div class="testStudent-body collection testStudent-body-mobile collection-mobile">
            <h2>Постановка предварительного диагноза</h2>
            <div class="diagnosis-body">
                <div class="diagnosis-left">
                    <h3>Выбранная патология</h3>
                    <v-skeleton-loader v-show="loading" v-for="inx in 4" :key="'c'+inx" type="list-item-two-line" />

                    <div class="left-item-column" v-show="!loading" v-for="(el, inx) in getDiagnosis.patalogy" :key="'g'+inx">
                        <h4>{{ el.key }}</h4>

                        <div class="left-item-column__list" v-for="(it, ind) in el.values" :key="'p'+ind">
                            <span v-if="it.valueType !== null">
                                <span v-if="it.valueType === 1">
                                    {{ it.pathologyName }}: {{ it.listValueName }}
                                </span>
                                <span v-if="it.valueType === 0">
                                    {{ it.pathologyName }}: {{ it.avgValue }} {{ it.measurementName }}
                                </span>
                            </span>

                            <span v-else>
                                <p>{{ it.pathologyName }}</p>
                            </span>

                            <div @click="openDelete(it, ind, el.key, 1)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M10.5909 9.73684C11.1181 9.73684 11.5455 10.161 11.5455 10.6842V16.8421C11.5455 17.3653 11.1181 17.7895 10.5909 17.7895C10.0637 17.7895 9.63636 17.3653 9.63636 16.8421V10.6842C9.63636 10.161 10.0637 9.73684 10.5909 9.73684Z" fill="#AAAEB7"/>
                                    <path d="M15.3636 10.6842C15.3636 10.161 14.9363 9.73684 14.4091 9.73684C13.8819 9.73684 13.4545 10.161 13.4545 10.6842V16.8421C13.4545 17.3653 13.8819 17.7895 14.4091 17.7895C14.9363 17.7895 15.3636 17.3653 15.3636 16.8421V10.6842Z" fill="#AAAEB7"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2516 1C9.90297 1 9.5821 1.1886 9.41453 1.49198L8.11652 5H2.95455C2.42736 5 2 5.42415 2 5.94737C2 6.47059 2.42736 6.89474 2.95455 6.89474H4.38636V22.0526C4.38636 22.5758 4.81373 23 5.34091 23H19.6591C20.1863 23 20.6136 22.5758 20.6136 22.0526V6.89474H22.0455C22.5726 6.89474 23 6.47059 23 5.94737C23 5.42415 22.5726 5 22.0455 5H16.889L15.6209 1.49907C15.4546 1.19174 15.1315 1 14.78 1H10.2516ZM14.7219 5L14.2092 2.89474H10.8169L10.2936 5H14.7219ZM6.29545 6.89474V21.1053H18.7045V6.89474H6.29545Z" fill="#AAAEB7"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="diagnosis-left right">
                    <h3>Поставьте предварительный диагноз</h3>
                    <v-autocomplete
                        label=""
                        outlined
                        height="46"
                        :search-input.sync="searchInput"
                        :items="getDiagnosis.mkb"
                        :loading="loadSpr"
                        :placeholder="loadSpr ? 'Данные подгружаются из справочника...' : 'Введите текст...'"
                        :no-data-text="calculateNoDataText"
                        item-text="nameCode"
                        item-value="id"
                        hide-details
                        return-object
                        class="combobxComp"
                        v-model="select"
                        @change="selectDiag(select)"
                    />
                    <div class="diagnosis-list-container-mobile">
                        <div class="diagnosis-list" v-for="(el, ind) in selected" :key="ind">
                            <div class="text">{{ el.nameCode }}</div>
                            <div class="icon" @click="openDelete(el, ind, null, 2)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M6 5L18.7279 17.7279" stroke="#AAAEB7" stroke-width="2" stroke-linecap="round"/>
                                    <path d="M6 18L18.7279 5.27208" stroke="#AAAEB7" stroke-width="2" stroke-linecap="round"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="button d-flex justify-end mt-8">
            <slot name="btn" />
        </div>

        <!-- <v-dialog v-model="showDlete" max-width="452" persistent>
            <div class="media-container">
                <div class="containerShadowN">
                    <v-btn class="bodySystems-close" :disabled="deletLoading" @click.prevent="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                            <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </v-btn>
                    <div class="deletEl deletEl-mobile">
                        <h2>{{ showObj.title }}</h2>
                        <div class="text-container">
                            <p>{{ showObj.text }}</p>
                        </div>
                        <div class="btn-container">
                            <v-btn :disabled="deletLoading" @click="close">Отменить</v-btn>
                            <v-btn :loading="deletLoading" @click="showObj.type == 1 ? deletePatalogy(deleteObject.el, deleteObject.key, deleteObject.ind) : deleteDiagnos(deleteObject.el, deleteObject.ind)">Удалить</v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </v-dialog> -->
        <v-dialog v-model="showDlete" persistent max-width="452" >
            <v-card>
                <v-card-title class="text-h5">
                    {{ showObj.title }}
                </v-card-title>
                
                <v-card-text>
                    {{ showObj.text }}
                </v-card-text>
                
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="v-btn-custom" :disabled="deletLoading" @click="close">Отменить</v-btn>
                    <v-btn class="v-btn-custom" :loading="deletLoading" @click="showObj.type == 1 ? deletePatalogy(deleteObject.el, deleteObject.key, deleteObject.ind) : deleteDiagnos(deleteObject.el, deleteObject.ind)">Удалить</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'syndromalDiagnosis',
    computed: {
        ...mapGetters({
            getDiagnosis: 'takeDiagnosticTest/getDiagnosis',
            getFirstStepOrNot: 'takeDiagnosticTest/getFirstStepOrNot'
        }),
        calculateNoDataText() {
            let text = 'Данных нет';
            if(this.loadSpr) text = 'Ждите, данные подгружаются из справочника...';
            if(!this.searchInput || (this.searchInput && (this.searchInput.length >= 0 && this.searchInput.length <= 2))) text = 'Введите минимум 3 символа для поиска';

            return text
        }
    },
    data() {
        return {
            loading: true,
            showObj: {
                title: '',
                text: '',
                type: ''
            },
            deletLoading: false,
            deleteObject: null,
            loadingPatalogy: false,
            searchInput: null,
            loadSpr: false,
            selected: [],
            select: null,
            showDlete: false,
            active: null
        }
    },
    watch: {
        searchInput(val) {
            if(val && val.length >= 3) this.getListMkb(val);
            else this.resetMkb()
        }
    },
    methods: {
        ...mapActions({
            getMkb: 'takeDiagnosticTest/getMkb',
            getDiagnoseAnswers: 'takeDiagnosticTest/getDiagnoseAnswers',
            getSections: 'takeDiagnosticTest/getSections',
            sendDiagnoseAnswers: 'takeDiagnosticTest/sendDiagnoseAnswers',
            getProcessPatologiesByDiagnoseType: 'takeDiagnosticTest/getProcessPatologiesByDiagnoseType',
            deletePatalogyByDiagnos: 'takeDiagnosticTest/deletePatalogyByDiagnos',
            deleteDiagnosis: 'takeDiagnosticTest/deleteDiagnosis'
        }),
        ...mapMutations({
            changeViewPage: 'takeDiagnosticTest/changeViewPage',
            resetMkb: 'takeDiagnosticTest/resetMkb',
            resetDiagnosis: 'takeDiagnosticTest/resetDiagnosis',
            checkingFirstStep: 'takeDiagnosticTest/checkingFirstStep'
        }),
        selectDiag(select) {
            if(select) {
                this.sendDiagnoseAnswers({ processId: this.$route.params.id, diagnoseId: select.id, diagnoseType: 2 })
                    .then(() => {
                        this.getSelected()
                            .then(() => {
                                this.resetMkb()
                                this.select = null;
                            })
                    })
                    .catch((error) => {
                        // console.log(error);
                    })
            }
        },
        openDelete(el, ind, key, type) {
            this.showObj = {
                title: `Удаление ${type == 1 ? 'патологии' : 'диагноза'}`,
                text: `Уважаемый студент, вы действительно хотите удалить ${type == 1 ? 'патологию' : 'диагноз'}?`,
                type: type
            }
            this.deleteObject = { el: el, key: key, ind: ind};
            this.showDlete = true;
        },
        itemDelete() {
            this.items[this.active].delete=true
            this.showDlete= false
        },
        getListMkb(query) {
            this.loadSpr = true;
            this.getMkb(query)
                .then(() => { this.loadSpr = false })
        },
        close() {
            this.showObj = { title: '', text: '', type: '' };
            this.deleteObject = null;
            this.showDlete = false;
        },
        deletePatalogy(item, key, index) {
            this.deletLoading = true;

            this.deletePatalogyByDiagnos({ processId: this.$route.params.id,  pathologyType: item.pathologyType, id: item.id, index: index, key: key })
                .then(() => {
                    this.deletLoading = false;
                    this.close();
                })
        },
        deleteDiagnos(item, index) {
            this.deletLoading = true;

            this.deleteDiagnosis(item.id)
                .then(() => {
                    this.selected.splice(index, 1);
                    this.deletLoading = false;
                    this.close();
                })
        },
        getSelected() {
            return new Promise((resolve, reject) => {
                this.getDiagnoseAnswers({ processId: this.$route.params.id, diagnoseType: 2 })
                    .then((res) => {
                        if(res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                if(res.data[i].diagnoseCode) res.data[i].nameCode = `${res.data[i].diagnoseCode}-${res.data[i].diagnoseName}`
                                else res.data[i].nameCode = res.data[i].diagnoseName
                            }
                        }
                        this.selected = res.data;
                        this.loading = false;
                        resolve(res)
                    })
                    .catch((error) => {
                        if(error) {
                            reject(error)
                        }
                    })
            })
        }
    },
    destroyed() {
        this.resetDiagnosis();
    },
    created() {
        this.loadingPatalogy = true;

        this.getSections(this.$route.query.diaTestId)
            .then(() => {
                this.changeViewPage('Постановка предварительного диагноза');
                this.checkingFirstStep();

                if(this.getFirstStepOrNot) {
                    this.introJS.setOptions({
                        steps: [
                            {
                                element: document.querySelector('.intro-info'),
                                intro: 'Обратите внимание на показатели пациента!',
                                position: 'bottom'
                            }
                        ]
                    }).start();
                }
            });
        this.getProcessPatologiesByDiagnoseType({ processId: this.$route.params.id, diagnoseType: 2 })
            .then(() => {
                this.loadingPatalogy = false;
            })
        this.getSelected();
    }
}
</script>
